<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-12">
            <h1>
              {{ $t("organization.organization") }}
              <router-link
                :to="{ name: 'OrganizationForm' }"
                class="btn ml-auto"
              >
                <i class="icon-plus"></i> {{ $t("new") }}
              </router-link>
            </h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">{{
                  $t("home")
                }}</router-link>
              </li>
              <li class="breadcrumb-item active">
                {{ $t("organization.organization") }}
              </li>
            </ol>
          </div>
        </div>
      </div>
      <!-- /.container-fluid -->
    </section>

    <section class="content" v-if="has_permission === true">
      <div class="container-fluid">
        <div class="card" id="organizations-organizations">
          <div
            class="card-header py-3"
            v-if="!_.isEmpty(organizations.data) && is_loading == false"
          >
            <div class="btn-toolbar pull-right">
              <el-dropdown
                split-button
                :trigger="'click'"
                @command="handleSelectedRows"
                type="primary"
                v-if="this.selected_row.length"
                class="mr-1"
              >
                {{ this.selected_row.length }}
                {{ "item" | pluralize(this.selected_row.length) }} selected
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click="bulkDelete()" command="delete">{{
                    $t("delete")
                  }}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <button
                class="btn btn-info"
                type="button"
                @click="show_filter = !show_filter"
              >
                <i class="fa fa-filter"></i> {{ $t("filter") }}
              </button>
            </div>
          </div>
          <form @submit.prevent="setFilters" method="GET" novalidate>
            <div class="card-body" v-if="show_filter">
              <div class="form-row">
                <div class="col-md-6">
                  <div class="form-group form-row">
                    <label class="col-md-3 col-form-label" for="org_name">{{
                      $t("name")
                    }}</label>
                    <div class="col-md-9">
                      <input
                        type="text"
                        class="form-control"
                        id="org_name"
                        v-model="filter.org_name"
                        placeholder="Name"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-9 offset-md-3">
                      <button type="submit" class="btn mr-3">
                        <i class="icon-search"></i> {{ $t("search") }}
                      </button>
                      <button
                        type="reset"
                        class="btn btn-outline"
                        @click="resetFilter()"
                      >
                        <i class="icon-refresh"></i>
                        {{ $t("reset") }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
          <div class="overlay" v-if="is_loading">
            <img src="/assets/images/loader.svg" alt="" />
          </div>

          <div class="card-body">
            <div v-if="!_.isEmpty(organizations.data) && is_loading == false">
              <div class="table-responsive-md">
                <table class="table">
                  <thead>
                    <tr>
                      <th style="width: 24px">
                        <label class="checkbox">
                          <input
                            type="checkbox"
                            v-model="is_selected_all"
                            @click="selectedRowAll()" />
                          <span class="checkmark"></span
                        ></label>
                      </th>
                      <th style="width: 10px">ID</th>
                      <th>
                        {{ $t("organization.organization") }}
                        <sort-icons :_sort="'org_name'" />
                      </th>
                      <th class="text-right">{{ $t("action") }}</th>
                    </tr>
                  </thead>
                  <tbody class="organizations-organizations">
                    <tr v-for="(val, index) in organizations.data">
                      <td>
                        <label class="checkbox">
                          <input
                            type="checkbox"
                            v-model="selected_row"
                            :value="val.id" />
                          <span class="checkmark"></span
                        ></label>
                      </td>
                      <td>{{ val.id }}</td>
                      <td>{{ val.org_name }}</td>
                      <td class="text-right">
                        <router-link
                          :to="{
                            name: 'OrganizationShow',
                            params: { id: val.id },
                          }"
                          class="btn btn-view"
                        >
                          <i class="icon-eye"></i>
                        </router-link>
                        <router-link
                          :to="{
                            name: 'OrganizationEdit',
                            params: { id: val.id },
                          }"
                          class="btn btn-edit"
                        >
                          <i class="icon-edit"></i>
                        </router-link>
                        <a
                          class="btn btn-trash"
                          href="javascript:void(0)"
                          @click="destroy(val.id, index)"
                          ><i class="icon-trash"></i
                        ></a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="mt-2 text-right d-block d-sm-none">
                Swipe <i class="icon-swipe"></i>
              </div>
            </div>
            <div
              class="col-12 p-4"
              v-if="_.isEmpty(organizations.data) && is_loading == false"
            >
              <div class="no-data">
                <img src="/assets/images/no-data.svg" alt="" />
                <h3>No data found!</h3>
              </div>
            </div>
          </div>

          <div
            :class="{
              'card-footer': organizations.total > organizations.per_page,
            }"
          >
            <vue-pagination
              :pagination="organizations"
              v-if="organizations.total > organizations.per_page"
              @paginate="getOrganizations()"
            />
          </div>
        </div>
      </div>
    </section>

    <section class="content" v-if="has_permission === false">
      <div class="alert alert-danger alert-dismissible">
        <h5><i class="icon fas fa-ban"></i> Permission denied!</h5>
      </div>
    </section>
  </div>
</template>

<script>
import VuePagination from "@/components/partials/PaginationComponent";
import SortIcons from "@/components/utils/SortIcons";
import { OrganizationsAPI } from "@/services/api";
const filterable = {
  org_name: null,
};
export default {
  name: "OrganizationList",
  metaInfo: {
    title: "Organization | Dotlines",
  },
  components: {
    VuePagination,
    SortIcons,
  },
  data: () => ({
    organizations: {
      total: 0,
      per_page: 1,
      from: 1,
      to: 0,
    },
    show_filter: false,
    filter: filterable,
    is_loading: false,
    has_permission: true,
    selected_row: [],
    is_selected_all: false,
  }),
  watch: {
    "$route.query"() {
      this.getOrganizations();
    },
  },
  mounted: function () {
    /* if (this.isMobile()) {
      window.$(document).find('.push-menu-class').trigger('click')
    } */
    this.getOrganizations();
    this.$root.$on("sort-data", () => {
      this.$root.$emit("show-icon");
    });
  },
  methods: {
    getOrganizations() {
      this.is_loading = true;
      const query = { ...this.filter, ...this.$route.query };

      OrganizationsAPI.index(query)
        .then((organizations) => {
          this.organizations = organizations;
        })
        .catch((error) => {
          if (error.response.status === 403) {
            this.has_permission = false;
          }
        })
        .finally(() => {
          this.is_loading = false;
        });
    },
    destroy: function (id, index) {
      // let _this = this;
      this.$swal
        .fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, delete it!",
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.is_loading = true;
            OrganizationsAPI.destroy(id)
              .then((response) => {
                this.organizations.data.splice(index, 1);
                this.organizations.total--;
                this.$toaster.success(response.message);
              })
              .catch((error) => {
                console.log("Could not delete this:: ", error);
                this.$swal.fire("Failed!", "Failed to delete.", "error");
              })
              .finally(() => {
                this.is_loading = false;
              });
          }
        });
    },
    selectedRowAll: function () {
      const isSelectedAll = (this.is_selected_all = !this.is_selected_all);
      if (isSelectedAll) {
        var items = [];
        this.organizations.data.forEach(function (item) {
          items.push(item.id);
        });
        this.selected_row = items;
      } else {
        this.selected_row = [];
      }
    },
    handleSelectedRows(command) {
      if (command === "delete") {
        console.log("Selected ID to Delete:: ", this.selected_row);
      }
    },
    async setFilters() {
      await this.$router
        .push({
          path: this.$route.path,
          query: this.filter,
        })
        .catch();
    },
    resetFilter() {
      this.filter = {};
      this.$router.push({ path: this.$route.path }).catch();
      this.$root.$emit("show-icon");
      this.show_filter = false;
    },
  },
};
</script>
